import React, { useState } from "react";
import "./filters.scss";
import moment from "moment";
import { useSelector } from "react-redux";
import Button from "../../../../../components/Button";
import { BooleanFilters } from "./BooleanFilters";
import { DateRangeFilters } from "./DateRangeFilters";
import { PropertyFilters } from "./PropertyFilters";
import { IssueTypeFilter } from "./IssueTypeFilter";
import { AssetTypeFilter } from "./AssetTypeFilter";
import { TagFilter } from "./TagFilter";
import { isRole } from 'src/helpers/permissions';
import { ServiceProviderFilter } from "./ServiceProviderFilter";
import { ServiceRequestFilters } from "src/pages/ServiceRequests/CustomHooks/useServiceRequestFilters";
import Callout from "src/components/InformationCallout/Callout";

interface FilterModalProps {
  onClose: () => void;
  filters: ServiceRequestFilters;
  applyFilters: (partial: Partial<ServiceRequestFilters>) => void;
}

export const FilterModal = ({
  onClose,
  filters,
  applyFilters,
}: FilterModalProps) => {
  const auth = useSelector((state: any) => state.auth);

  const roleCondition = isRole(
    [
      "Admin",
      "Super Admin",
      "Property Developer",
      "Service Manager",
      "Strata Manager",
    ],
    auth.user
  );

  const [dates, setDates] = useState({
    startDate: filters?.SubmittedFrom
      ? moment(filters?.SubmittedFrom).toDate()
      : null,
    endDate: filters?.SubmittedTo
      ? moment(filters?.SubmittedTo).toDate()
      : null,
  });

  const [propertyFilters, setPropertyFilters] = useState({
    suite: filters.UnitId ?? [],
    project: filters?.PropertyId ?? "",
    building: filters?.BuildingId ?? "",
    level: filters?.LevelId ?? "",
  });

  const { suite, project, building, level } = propertyFilters;

  const [booleanFilters, setBooleanFilters] = useState(
    filters?.booleanFilters ?? []
  );

  const [issueType, setIssueType] = useState(filters?.ServiceType);
  const [assetType, setAssetType] = useState(filters?.ItemTypeId);
  const [tags, setTags] = useState(filters?.TagIds ?? []);
  const [assignTo, setAssignTo] = useState(filters?.AssignedToServiceProviderId);

  function handleSubmit() {
    const filtersToApply = {
      booleanFilters,
      AssignedToServiceProviderId: assignTo,
      SubmittedFrom: dates.startDate
        ? moment(dates.startDate).format('YYYY-MM-DD')
        : null,
      SubmittedTo: dates.endDate
        ? moment(dates.endDate).format('YYYY-MM-DD')
        : null,
      PropertyId: project,
      UnitId: suite,
      BuildingId: building,
      LevelId: level,
      TagIds: tags,
      ServiceType: issueType,
      ItemTypeId: assetType,
    };

    applyFilters(filtersToApply);

    onClose();
  }

  return (
    <>
      <div className="filters-modal__heading">Filter By</div>
      <div className="filters_modal_top_coner_box">
      </div>
      <Callout
        variant="info"
        title="These filters are saved for the Service Request dashboard only"
        subtitle="Filters applied here persist across navigation and refreshes until you clear them or sign out. Filters on other pages aren't saved."
        className="filters-modal-callout"
      />
      <BooleanFilters
        booleanFilters={booleanFilters}
        setBooleanFilters={setBooleanFilters}
      />
      <DateRangeFilters dates={dates} setDates={setDates} />
      <PropertyFilters
        propertyFilters={propertyFilters}
        setPropertyFilters={setPropertyFilters}
      />
      <IssueTypeFilter
        setSelectedIssueType={setIssueType}
        issueType={issueType}
      />
      <AssetTypeFilter
        assetType={assetType}
        setSelectedAssetType={setAssetType}
      />
      {roleCondition && (
        <ServiceProviderFilter
          assignedTo={assignTo}
          setAssignedTo={setAssignTo}
        />
      )}
      <TagFilter tags={tags} setTags={setTags} />
      <div className="filters-modal__submit">
        <Button
          color="teal"
          label="Submit"
          size="small"
          onClick={handleSubmit}
        />
      </div>
    </>
  );
};
